import React, { useEffect, useState } from "react";

import EventPage from "./EventPage";
import { genStartTimesOptions, parseStartTimesQuery } from "./EventSearchFunc";

import { useAppSelector } from "../../redux/hooks";
import { getAuthToken } from "../../redux/reducers/auth";

import {
  getTimeStampYesterday,
  parseTermSearchQuery,
  useQuery,
} from "../../utils/GeneralUtils";
import { useMetaData } from "../../utils/useMetaData";
import { useGetEvents } from "../../utils/useEvent";
import {
  checkParamExist,
  getCurrentPage,
  getCurrentPerView,
  getParam,
  getParamAll,
  handlePerView,
  searchClearHandler,
  searchHandler,
  SearchParam,
} from "../../common/archive/ListSearchFunc";
import { useLocation, useNavigate } from "react-router-dom";
import { TermType, useGetTerm } from "../../utils/useTerm";

const EventPageContainer: React.FC = () => {
  const auth_token = useAppSelector(getAuthToken);

  const query = useQuery();
  const location = useLocation();
  const navigate = useNavigate();

  const {
    termData: { entries: games },
    getTermLoading: isGameLoading,
  } = useGetTerm(TermType.Games, undefined, -1);
  const {
    termData: { entries: eventTypes },
    getTermLoading: isTypeLoading,
  } = useGetTerm(TermType.EventTypes, undefined, -1);

  const [enabled, setEnabled] = useState<boolean>(
    !checkParamExist(query, [TermType.Games, TermType.EventTypes])
  );

  useEffect(() => {
    if (enabled === true) return;

    if (!isGameLoading && !isTypeLoading) {
      setEnabled(true);
    }
  }, [isGameLoading, isTypeLoading]);

  let selectedTypes: { ids: Array<string>; names: Array<string> } = {
    ids: [],
    names: [],
  };
  let selectedGames: { ids: Array<string>; names: Array<string> } = {
    ids: [],
    names: [],
  };

  if (!isGameLoading && !isTypeLoading) {
    const gameParams = getParamAll(query, "games");
    selectedGames = {
      ids: parseTermSearchQuery(gameParams, games, "id"),
      names: gameParams,
    };

    const typeParams = getParamAll(query, "events");
    selectedTypes = {
      ids: parseTermSearchQuery(typeParams, eventTypes, "id"),
      names: typeParams,
    };
  }

  const startTimes = getParam(query, "start_times") ?? "";
  const pageType = getParam(query, "page_type") ?? "";

  const searchArgs = {
    auth_token: auth_token,
    search: getParam(query, "s"),
    games: selectedGames.ids.length > 0 ? selectedGames.ids : [],
    event_types: selectedTypes.ids.length > 0 ? selectedTypes.ids : [],
    page: getCurrentPage(query),
    per: getCurrentPerView(query),
    sort_by:
      pageType !== "finished"
        ? ["start_date", "start_time"]
        : ["end_date", "start_time"],
    desc: pageType !== "finished" ? false : true,
    date_end_before:
      pageType !== "finished" ? undefined : getTimeStampYesterday(),
    start_time_min: parseStartTimesQuery(startTimes, "min"),
    start_time_max: parseStartTimesQuery(startTimes, "max"),
  };

  const {
    items: { events, total_entries: entries, total_pages: totalPage },
    isLoading,
  } = useGetEvents(searchArgs, enabled);

  useMetaData({
    title: "eスポーツイベント一覧",
    description:
      "eスポーツを使ったPRやイベントキャスティングサービス「SELeCT」のeスポーツやゲームに関する大会・イベントの一覧ページです。過去に開催されたイベントやこれから開催予定のイベントまでご覧いただけます。キーワード・カテゴリでの検索もご利用いただけます。",
    imgUrl: "",
  });

  return (
    <EventPage
      isLoading={isLoading}
      sorted_events={events}
      totalEntries={entries}
      totalPages={totalPage}
      currentPage={searchArgs.page}
      perView={searchArgs.per}
      keywordParam={searchArgs.search ?? ""}
      isNormalArchive={pageType === "finished" ? false : true}
      typeParams={selectedTypes.names}
      gameParams={selectedGames.names}
      startTimeParam={startTimes}
      handlePerView={(value: number) =>
        handlePerView(query, location, navigate, value)
      }
      handleArchiveType={(isNormalArchive: boolean) => {
        searchHandler(
          query,
          [{ field: "page_type", value: isNormalArchive ? "" : "finished" }],
          navigate
        );
      }}
      searchHandler={(params: Array<SearchParam>) => {
        searchHandler(query, params, navigate);
      }}
      clearSearch={() => searchClearHandler(navigate)}
      eventTypeOptions={eventTypes}
      gameOptions={games}
      startTimesOptions={genStartTimesOptions()}
    />
  );
};

export default EventPageContainer;
